import React from "react";
import MUICard from "../MUICard/MUICard.component";
import { AppTheme } from "../../theme/App.theme";
import { Typography, useMediaQuery } from "@mui/material";
import { Icons } from "../../config/MuiIcons.config";
import { useNavigate } from "react-router-dom";
import MUITableSearch from "../MUITableSearch/MUITableSearch";

const SubHeaderComponent = ({
  title,
  backButton = true,
  backButtonHandler,
  searchText = "",
  handleSearch = () => {},
  cancelSearch = () => {},
  isSubHeaderVisible = false,
  isSearchBarVisible = true,
}) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:600px)");

  if (!isSubHeaderVisible) return null;

  const containerPadding = isMobile ? "12px 16px" : "10px 20px";
  const searchPlaceholder = isMobile ? "Search news and articles..." : "Search";

  return (
    <MUICard
      padding={0}
      removeDefaultPadding
      className={"w-100"}
      removeBorder
      style={{
        borderBottom: `1px solid ${AppTheme.BORDER_COLOR}`,
        borderRadius: 0,
      }}
    >
      <div
        style={{
          width: "100%",
          boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
          padding: containerPadding,
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "stretch" : "center",
          justifyContent: "space-between",
          gap: isMobile ? 10 : 0,
        }}
      >
        {/* Top row: back + centered title */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            position: "relative",
            justifyContent: isMobile ? "center" : "flex-start",
            flex: isMobile ? "0 0 auto" : 1,
          }}
        >
          {backButton && (
            <div
              onClick={() => {
                if (backButtonHandler) {
                  backButtonHandler();
                } else {
                  navigate(-1)
                }
              }}
              style={{
                position: isMobile ? "absolute" : "static",
                left: isMobile ? 0 : "auto",
                cursor: 'pointer'
              }}
            >
              <Icons.ChevronLeftIcon fontSize="medium" sx={{ color: "#2D3748" }} />
            </div>
          )}

          <Typography
            className="plus-jakarta-sans-semi-bold-600"
            variant="h6"
            sx={{ fontSize: isMobile ? "20px" : "19px" }}
            style={{
              width: isMobile ? "100%" : "auto",
              textAlign: isMobile ? "center" : "left",
              paddingLeft: isMobile ? 0 : 8,
            }}
          >
            {title}
          </Typography>
        </div>

        {/* Search */}
        {isSearchBarVisible && (
          <div
          style={{
            display: "flex",
            alignItems: "center",
            width: isMobile ? "100%" : 440,
            marginTop: isMobile ? 8 : 0,
          }}
        >
          <MUITableSearch
            SearchText={searchText}
            HandleSearch={handleSearch}
            CancelSearch={cancelSearch}
            placeholder={searchPlaceholder}
            size={isMobile ? "medium" : "small"}
          />
        </div>
        )}
      </div>
    </MUICard>
  );
};

export default SubHeaderComponent;